import React from "react";
import { AzureRecommendationSummaryDto } from "../../../../../../customer-experience/src/lib/ShiOneClient";
import { RecommendationItemAdditionalContentProps } from "../../recommendations";
import { RecommendationListItemAdditionalContent } from "../RecommendationListItemAdditionalContent";

export const AzureListItemAdditionalContent: React.FC<
  RecommendationItemAdditionalContentProps<AzureRecommendationSummaryDto>
> = ({ recommendation }) => {
  const totalResources =
    recommendation.affectedSubscriptions?.reduce(
      (total, sub) => total + (sub.affectedResources?.length || 0),
      0,
    ) || 0;

  const displayedResources =
    recommendation.affectedSubscriptions
      ?.flatMap((sub) => sub.affectedResources || [])
      .slice(0, 5) || [];

  if (totalResources === 0) {
    return null;
  }

  return (
    <RecommendationListItemAdditionalContent
      displayedResources={displayedResources}
      totalResources={totalResources}
    />
  );
};
